import { render, staticRenderFns } from "./PeiRevision.vue?vue&type=template&id=4094ae68&"
import script from "./PeiRevision.vue?vue&type=script&lang=js&"
export * from "./PeiRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports